<template>
  <div class="home-page cg-page" style="padding-top: 0;">
    <div class="login-content">
      <div class="pt20 disflex" >
        <a class="logo" style="text-align: left;margin: 0 20px -80px;position: relative;" href="/"><img src="static/images/logo.png" /></a>
      </div>
      <div class="landing-page">
        <div class="">
          <div class="home-prize" style="padding-top:30px;">
            <div class="home1 ac mt50">
              <img  src="../../static/images/login-pic.png">
            </div>
          </div>
          <div class="span fs33 ac mt30 app-en" style="width:50%;margin: 0 auto;">
            {{ msg }}
          </div>
          <div class="ac mt50">
            <button class="btn btn-blue btn-green0 mt50" style="min-width: 350px;">
              <span @click="goLogin">{{$t('subscribeNow')}}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Header from '../components/HeaderTwo'
export default {
  components:{
    Header
  },
  data() {
    return {
      list:[],
      account:'',
      password:'',
      isShow:false,
      type:'daily',
      isEN:'bur',
      mobile:'',
      msg:'',
    }
  },
  created(){
    let msg = this.$route.query.msg
    if(msg){
      this.msg = msg
    }
    if(localStorage.getItem('lang')) this.isEN = localStorage.getItem('lang')
  },
  methods: {
    back(){
      this.$router.go(-1);
    },
    clickDrown(){
      this.isShow = !this.isShow
    },
    goLogin(){
      this.$router.push({path:'/login'});
    },
  }
}
</script>
<style scoped>
.drop-down-content{z-index:9;background:none;}
.landing-page{padding-bottom:60px;}
</style>



// WEBPACK FOOTER //
// src/page/errors.vue